module.exports = __webpack_public_path__ + "3de42eda6b5b4f942400cb1eb467aa96.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/tomhorn/assets/170.png
// module id = 1761
// module chunks = 2